const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;opacity:0.2;}"));

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  className: "cls-1",
  width: 24,
  height: 24
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  points: "8.71 21.71 8.71 21.71 8.71 21.71 8.71 21.71"
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.71.29a1,1,0,0,0-1.42,0l-15,15h0a1.1,1.1,0,0,0-.26.43H2l-2,7A.84.84,0,0,0,0,23H0a1,1,0,0,0,.07.34l0,.07a1.32,1.32,0,0,0,.19.29,1.32,1.32,0,0,0,.29.19l.07,0A1,1,0,0,0,1,24H14a1,1,0,0,0,1-1,1,1,0,0,0-1-.95H8.14L8.28,22a1.07,1.07,0,0,0,.42-.26h0l15-15a1,1,0,0,0,0-1.42ZM7.48,20.11l-5,1.43,1.43-5L15,5.41,18.59,9ZM20,7.59,16.41,4,18,2.41,21.59,6Z"
});

const SvgEditLine = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEditLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/edit-line.9bb15ef6.svg";
export { ForwardRef as ReactComponent };